// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zxp5","importantInfo":"styles_importantInfo__3kKrk"};